import { AfterViewInit, Directive, HostListener, Inject, Input, SkipSelf } from "@angular/core";
import { ImmutableRedux } from "../../../../redux/immutable-redux.service";
import { FormPostMessageActionsDirective } from "../../../global-message/form-post-message/actions.directive";
import { GenericFormActions } from "../../actions";
import { CommonFormManagerDirective } from "../../form-manager.directive";
import { FORM_CTAS_STATE_PROP, FORM_STATE_PROP } from "../../state-props";

@Directive({
    selector: "[save-form-cta]",
    exportAs: "SaveFormCta",
})
export class SaveFormCtaDirective implements AfterViewInit {
    @Input() public stateProp: string;
    @Input() public formManager: CommonFormManagerDirective;
    @Input() public closeWhenSaved = true;
    @Input() public skipReset = false;
    @Input() public setFieldBeforeSave: [string, string];
    @Input() public buttonIsLocked = false;

    constructor(
        public ngRedux: ImmutableRedux<any>,
        @Inject(FORM_CTAS_STATE_PROP) public rootProp,
        @Inject(FORM_STATE_PROP) public formStateProp,
        @SkipSelf() private onSaveActions: FormPostMessageActionsDirective,
    ) { }

    public ngAfterViewInit() {
        this.formManager.formSaveAttempt.subscribe((e) => {
            this.buttonIsLocked = false;

            if (e.closeOnSave) {
                this.ngRedux.dispatchFactory(GenericFormActions.FORM_CLOSED, this.rootProp, this.stateProp);
            }

            if (e.success) {
                this.onSaveActions.addMessage("save successful!", "success");
            }

            if (!e.success && e.isServerError) {
                this.onSaveActions.addMessage(e.message, "error");
            }
        });
    }

    @HostListener("click", ["$event"])
    public clickCta(event: Event) {
        event.stopPropagation();

        if (!this.setFieldBeforeSave) {
            this.saveFormAttempt();
            return;
        }

        if (!this.formManager.validityCheckPasses) { return; }

        const [fieldProp, val] = this.setFieldBeforeSave;
        this.ngRedux.dispatchFactory(
            GenericFormActions.FIELD_VALUE_UPDATED,
            this.formStateProp,
            this.stateProp,
            val,
            { fieldProp },
        );

        this.saveFormAttempt();
    }

    public saveFormAttempt() {
        if (!this.buttonIsLocked) {
            this.buttonIsLocked = true;
            this.formManager.saveForm(this.closeWhenSaved, this.skipReset);
        }
    }
}
